import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { selfieCopy } from '@/Pages/Selfie/copy';
import '@/Pages/Selfie/SelfiePage.sass';

export function SelfieValidationHeader(): JSX.Element {
  return (
    <Box
      component="section"
      className="selfie-validation-header"
      data-testid="selfie-validation-header"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Typography component="h1" className="selfie-validation-header__title">
        {selfieCopy.validationTitle}
      </Typography>
      <Typography component="p" className="selfie-validation-header__description">
        {selfieCopy.validationDescription}
      </Typography>
    </Box>
  );
}
